export default "assets/dragon-graphic-960-Bftpj8Mo.webp"